import { useRef } from 'react';
import { LiveRegionRefType } from '../../LiveRegion';

type BroadcastMessage = (message: string | undefined) => void;

const useBroadcast = (): [
  React.RefObject<LiveRegionRefType>,
  BroadcastMessage,
] => {
  const liveRegionRef = useRef<LiveRegionRefType>(null);

  const broadcast: BroadcastMessage = message => {
    message &&
      liveRegionRef.current?.broadcast({
        message,
      });
  };

  return [liveRegionRef, broadcast];
};

export { useBroadcast };
